/**
 * Schedule UI layout tokens: panel width, row height, day-cell widths per zoom, bar insets.
 * Shared by header, grid, and ScopeBars for consistent geometry. Visual tokens live in style.js.
 */

/** In-page jobs / groups column width (px). */
export const SCHEDULE_LEFT_PANEL_WIDTH = 256;

/** Height of one schedule row: project, group, or bar band (px). */
export const SCHEDULE_ROW_HEIGHT = 30;

/** Timeline column width by numeric zoom level (px per day cell). */
export const SCHEDULE_CELL_WIDTH_PX = {
  1: 52,
  2: 34,
  3: 20,
};

/**
 * Cell width before `TimelineHeader` completes first layout.
 * Keep in sync with the default zoom (2).
 */
export const SCHEDULE_DEFAULT_CELL_WIDTH_PX = SCHEDULE_CELL_WIDTH_PX[2];

/**
 * Minimum day columns to render at each zoom so the grid fills the viewport.
 */
export const SCHEDULE_MIN_VISIBLE_CELLS = {
  1: 10,
  2: 21,
  3: 28,
};

/** Zoom levels from most detail (1) to least detail (3). */
export const SCHEDULE_ZOOM_ORDER = Object.freeze([1, 2, 3]);

/**
 * Backend assigns orphans under job-level schedule groups with this label (`schedule/functions`).
 * Used when judging Dispatch-only placeholder rows for "Hide Empty Projects".
 */
export const SCHEDULE_DISPATCH_GROUP_NAME = "Dispatch";

/** Weeks of schedule block data to load on each side of the timeline anchor. */
export const SCHEDULE_DATA_WINDOW_WEEKS = 3;

/** When visible days are this close to the loaded edge, prefetch the next chunk. */
export const SCHEDULE_PREFETCH_THRESHOLD_DAYS = 7;

/**
 * ScopeBar placement inside the row band (px).
 *
 * @type {{ leftOffset: number, widthShrink: number, topOffset: number, verticalMargin: number, minWidth: number, minHeight: number }}
 */
export const SCHEDULE_BAR = {
  /** Inset from the left edge of the first day column. */
  leftOffset: 1,
  /** Shrink total bar width so handles do not overflow the last column. */
  widthShrink: 2,
  /** Inset from the top of the row band. */
  topOffset: 2,
  /** Vertical margin inside the row band (affects min height). */
  verticalMargin: 4,
  /** Minimum rendered bar width (px). */
  minWidth: 8,
  /** Minimum rendered bar height (px). */
  minHeight: 14,
};
